export default "__VITE_ASSET__Dj5SvxQ7__"